import React from 'react';
import styled from 'styled-components';
import { Drawer as MuiDrawer } from '@mui/material';
import { selectors as authSelectors } from 'services/auth';

import logo from 'lib/icons/logo_white.png';
import { useSelector } from 'react-redux';

const Logo = () => {
  const { whiteLabelLogoUrl } = useSelector(authSelectors.getLogo);

  return (
    <div style={{ padding: '15px' }}>
      <img
        src={whiteLabelLogoUrl ? whiteLabelLogoUrl : logo}
        width={50}
        height={50}
        alt="Logo"
        onError={(e) => e.target.src = logo}
      />
    </div>
  )
};

export const SLogo = styled(Logo)`
  margin: 20px auto 0;
  height: 60px;
`;

export const SListContainer = styled('div')`
  display: flex;
  height: ${(props) => props.height || 'auto'};
  flex-direction: column;
  justify-content: center;
`;

export const SDrawer = styled(({ className, ...props }) => (
  <MuiDrawer {...props} className={className} classes={{ paper: className }} />
))`
  ${({ theme }) => `
    background-color: ${theme.palette.primary.main} !important;
    width: 80px;
    z-index: 1300;
    overflow-y: visible !important;
  `}
`;
